import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
// Public Pages
import Login from '../pages/login/Login';
import Signup from '../pages/signup/Signup';
import Forgotpassword from '../pages/forgot-password/ForgotPassword';
import Account from '../pages/account-setting/Account';
import ProcessTitle from '../pages/add-process/AddProcess';
import Dashboard from '../pages/dashboard/Dashboard';
import ManageAssignedUsers from '../pages/manage-assigned-users/ManageAssignedUsers';
import AddUser from '../pages/manage-assigned-users/AddUser';
import EditUser from '../pages/manage-assigned-users/EditUser';
import SignupForm from '../pages/signup/SignupForm';
import Setting from '../pages/setting/Setting';
import ResetPassword from '../pages/forgot-password/ResetPassword';
import MapResolver from './resolvers/MapResolver';
import MapLevel from '../pages/map-level/MapLevel';
import SwimlaneResolver from './resolvers/SwimlaneResolver';
import SwimlaneModel from '../pages/map-level/SwimlaneModel';
import LegalPage from '../pages/legal/LegalPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/signup-form" element={<SignupForm />} />
      <Route path="/forgot-password" element={<Forgotpassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/page/:slug" element={<LegalPage />} />
      {/* Private Routes */}

      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/account/settings" element={<Account />} />
        <Route path="/setting" element={<Setting />} />
        {/* <Route path="/profile" element={<Profile />} /> */}
        <Route path="/users" element={<ManageAssignedUsers />} />
        <Route path="/users/create" element={<AddUser />} />
        <Route path="/users/edit" element={<EditUser />} />
        <Route path="/processes/create" element={<ProcessTitle />} />
        {/* <Route path="/list-process-title" element={<ListProcessTitle />} /> */}

        {/* MAP */}
        <Route path=":mode/map/:processId" element={<MapResolver />} />
        <Route path=":mode/map/:processId/:level/:parentId" element={<MapResolver />} />

        {/* SWIMLANE */}
        <Route path=":mode/swimlane/:processId" element={<SwimlaneResolver />} />
        <Route path=":mode/swimlane/:processId/:level/:parentId" element={<SwimlaneResolver />} />
        <Route
          path="/swimlane-version/:processId/:level/:version/:pageTitle/:user_id/:currentParentId"
          element={<SwimlaneModel />}
        />
        <Route
          path="/process-version/:processId/:level/:version/:pageTitle/:user_id/:currentParentId"
          element={<MapLevel />}
        />
      </Route>
      {/* Redirect for unknown routes */}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;
